import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MdDiamond, MdHouse, MdMail, MdPhone } from "react-icons/md";
import { languageHelper } from "../../config/helperFunctions";
import axios from "axios";
import { apiKey } from "../../config/config";
import { useLocation } from "react-router-dom";

function Footer({ logo, generalSetting }) {
  const [socialMedia, setSocialMedia] = useState([]);

  const location = useLocation();

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/customer/socialmedia`)
      .then((res) => {
        setSocialMedia(res.data);
      })
      .catch((err) => console.log(err));
  }, []);

  if (location.pathname.includes("/trackorder") || location.pathname.includes("/thankyou")) return null

  return (
    <footer className="bg-white shadow-[rgba(0,0,15,0.5)_10px_5px_4px_4px]">
      <div className="px-4 pt-4 pb-24 lg:px-6 lg:py-16 mx-auto max-w-screen-xl">
        <div className="flex justify-center lg:justify-between gap-x-8 gap-y-4 flex-wrap">
          <div className="mb-6 md:mb-0">
            <span className="text-lg flex items-center gap-4 text-gray-500">
              <MdDiamond /> {generalSetting?.restaurant_name}
            </span>
            <Link to={"/"} className="my-8">
              <img src={logo} className="w-32" alt="FlowBite Logo" />
            </Link>
            {/* <p className="mt-8 text-sm">© 2024 Imdady . All rights reserved</p> */}
          </div>
          <div className="text-gray-500">
            <h2 className="mb-6 text-lg uppercase">
              {languageHelper("contact") || "Contact"}
            </h2>
            <ul>
              <li className="mb-4">
                <p className="hover:underline flex gap-4 items-center">
                  <MdHouse /> {generalSetting?.address}
                </p>
              </li>
              <li className="mb-4">
                <p className="hover:underline flex gap-4 items-center">
                  <MdMail /> {generalSetting?.email}
                </p>
              </li>
              <li className="mb-4">
                <p className="hover:underline flex gap-4 items-center">
                  <MdPhone /> {generalSetting?.phone}
                </p>
              </li>
            </ul>
          </div>
          <div className="text-gray-500">
            <h2 className="mb-6 text-lg uppercase">
              {languageHelper("follow us") || "Follow Us"}
            </h2>
            <ul className="flex gap-2 items-center">
              {socialMedia.map((item, idx) => (
                <li key={idx}>
                  <a href={item.link} target="_blank" rel="noopener noreferrer" className="hover:underline ">
                    <img src={item.icon_url} className="h-12" alt="" />
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div className="text-gray-500">
            <h2 className="mb-6 text-lg uppercase">
              {languageHelper("our timings") || "Our Timings"}
            </h2>
            <ul>
              <li className="mb-4">
                <p className="hover:underline">
                  {generalSetting?.days}
                </p>
              </li>
              <li className="mb-4">
                <p className="hover:underline">
                  {generalSetting?.hours}
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="text-lg text-white text-center bg-w-bg py-4 mb-16 lg:mb-0">
        <a className="hover:underline" href=" https://rms.methologik.com/">
          {languageHelper("Powered by: ")}
          <span className="font-bold">Imdady</span>
        </a>
      </div>
    </footer>
  );
}

export default Footer;
